'use client';

import React, { useMemo } from 'react';

import { DEFAULT_SCREEN, OnboardingScreen, OnboardingView } from '../../constants/user-onboarding-constants';
import { UserOnboardingProvider, useUserOnboarding } from '../../contexts/user-onboarding-provider';
import { UserNameScreen } from '../screens/user-name-screen';
import { WorkspaceCreateScreen } from '../screens/workspace-create-screen';

type UserOnboardingProps = {
	defaultScreen?: OnboardingScreen;
	allowedScreens?: OnboardingScreen[];
	onComplete?: (data: { userName: string; workspaceName: string; workspacePhoto?: string }) => void;
	source?: string;
	skipLayout?: boolean;
	onScreenChange?: (screen: OnboardingView) => void;
};

function UserOnboarding({
	defaultScreen = DEFAULT_SCREEN,
	onComplete,
	allowedScreens,
	source,
	skipLayout,
	onScreenChange,
}: UserOnboardingProps) {
	return (
		<UserOnboardingProvider
			defaultScreen={defaultScreen}
			onComplete={onComplete}
			allowedScreens={allowedScreens}
			source={source}
			skipLayout={skipLayout}
			onScreenChange={onScreenChange}
		>
			<OnboardingFlow />
		</UserOnboardingProvider>
	);
}

export default UserOnboarding;

function OnboardingFlow() {
	const { currentScreen } = useUserOnboarding();

	const currentScreenComponent = useMemo(() => {
		switch (currentScreen) {
			case OnboardingScreen.USER_NAME:
				return <UserNameScreen />;
			case OnboardingScreen.WORKSPACE_DETAILS:
				return <WorkspaceCreateScreen />;
			default:
				return null;
		}
	}, [currentScreen]);

	return currentScreenComponent;
}
